import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { Button, Space } from 'antd';
import { DeleteOutlined, FileOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { PopupConfirm, styleVariables } from '@lib/common';
import { Size } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Content = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  border: 1px solid ", ";\n  border-radius: 4px;\n\n  width: 100%;\n\n  padding: 8px 16px 8px 8px;\n"])), styleVariables.colors.gray6);
var FileSize = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: ", ";\n"])), styleVariables.colors.gray10);
var VerticalLine = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 10px;\n\n  background: ", ";\n"])), styleVariables.colors.gray9);
var DeleteButton = styled(Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 30px;\n\n  border-radius: 50%;\n\n  &:hover {\n    background: lightgray;\n  }\n"])));
var FileIcon = styled(FileOutlined)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 32px;\n"])), styleVariables.colors.blue3);
var FileName = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  max-width: 300;\n\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])));
export var ImportedFilePreview = function ImportedFilePreview(props) {
  var size = props.size,
      name = props.name,
      onDelete = props.onDelete,
      label = props.label;
  return /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      size: 'middle',
      align: "center",
      children: [/*#__PURE__*/_jsx(FileIcon, {}), /*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [/*#__PURE__*/_jsx(FileName, {
          children: name
        }), /*#__PURE__*/_jsx(FileSize, {
          children: Size.format(size)
        })]
      })]
    }), /*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      size: "middle",
      children: [/*#__PURE__*/_jsx(VerticalLine, {}), /*#__PURE__*/_jsx(PopupConfirm, {
        okText: label.yes,
        cancelText: label.no,
        title: label.deleteMessage,
        onConfirm: onDelete,
        children: /*#__PURE__*/_jsx(DeleteButton, {
          type: "text",
          icon: /*#__PURE__*/_jsx(DeleteOutlined, {})
        })
      })]
    })]
  });
};